(function () {
  if (window.__LABFitCompareReady) return;
  window.__LABFitCompareReady = true;

  function getData(root) {
    if (root.__fitCompareData) return root.__fitCompareData;

    const dataEl = root.querySelector('[data-fit-compare-data]');
    if (!dataEl) return null;

    let parsed;
    try { parsed = JSON.parse(dataEl.textContent); } catch (e) { return null; }

    const fits = Array.isArray(parsed.fits) ? parsed.fits : [];
    if (!fits.length) return null;

    const byId = new Map(fits.map(f => [String(f.id), f]));
    root.__fitCompareData = { fits, byId };
    return root.__fitCompareData;
  }

  function render(root, col, fitId) {
    const data = getData(root);
    if (!data) return;

    const fit = data.byId.get(String(fitId)) || data.fits[0];
    if (!fit) return;

    const imgWrap = root.querySelector(`[data-fit-compare-image-wrap="${col}"]`);
    const img = root.querySelector(`[data-fit-compare-image="${col}"]`);
    const bulletsEl = root.querySelector(`[data-fit-compare-bullets="${col}"]`);
    const descEl = root.querySelector(`[data-fit-compare-desc="${col}"]`);

    if (imgWrap && img) {
      if (fit.image) {
        img.src = fit.image;
        img.alt = fit.label || '';
        imgWrap.style.display = '';
      } else {
        img.removeAttribute('src');
        imgWrap.style.display = 'none';
      }
    }

    if (bulletsEl) {
      bulletsEl.innerHTML = '';
      (Array.isArray(fit.bullets) ? fit.bullets : []).forEach(t => {
        if (!t) return;
        const li = document.createElement('li');
        li.textContent = t;
        bulletsEl.appendChild(li);
      });
    }

    if (descEl) descEl.innerHTML = fit.description || '';
  }

function init(root) {
  if (!root || root.dataset.fitCompareInit === '1') return;
  root.dataset.fitCompareInit = '1';

  const data = getData(root);
  if (!data) return;

  const selects = [...root.querySelectorAll('[data-fit-compare-select]')];
  if (selects.length < 2) return;

  const sel1 = selects.find(s => s.getAttribute('data-fit-compare-select') === '1') || selects[0];
  const sel2 = selects.find(s => s.getAttribute('data-fit-compare-select') === '2') || selects[1];

  // --- Defaults: always different ---
  const fit1 = data.fits[0];
  const fit2 = data.fits.find(f => String(f.id) !== String(fit1.id)) || fit1;

  sel1.value = String(fit1.id);
  sel2.value = String(fit2.id);

  render(root, '1', sel1.value);
  render(root, '2', sel2.value);

  function enforceUnique(changedSel) {
    const otherSel = changedSel === sel1 ? sel2 : sel1;

    // If both are the same, move the other one to an alternative
    if (otherSel.value === changedSel.value) {
      const alternative = data.fits.find(f => String(f.id) !== String(changedSel.value));
      if (alternative) {
        otherSel.value = String(alternative.id);
        render(root, otherSel.getAttribute('data-fit-compare-select'), otherSel.value);
      }
    }
  }

  // Bind directly to each select (no bubbling reliance)
  [sel1, sel2].forEach((sel) => {
    const col = sel.getAttribute('data-fit-compare-select');

    sel.addEventListener('change', () => {
      enforceUnique(sel);
      render(root, col, sel.value);
    });

    sel.addEventListener('input', () => {
      enforceUnique(sel);
      render(root, col, sel.value);
    });
  });
}

  // Public helper you can call from console
  window.LABFitCompareHandle = function (selectEl) {
    const root = selectEl?.closest?.('[data-fit-compare]');
    if (!root) return;
    const col = selectEl.getAttribute('data-fit-compare-select');
    render(root, col, selectEl.value);
  };

  // Init existing
  document.querySelectorAll('[data-fit-compare]').forEach(init);

  // Init injected later (modal open)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('[data-fit-compare]')) init(node);
        node.querySelectorAll?.('[data-fit-compare]').forEach(init);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();